import TagManager from "react-gtm-module";

function ProfileInfoEdit({ ipeds }) {
  const tagManagerArgs = {
    dataLayer: {
      event: "interactionEvent",
      eventName: "profile_info_edit",
      ipeds: ipeds,
    },
  };

  TagManager.dataLayer(tagManagerArgs);
}

export default ProfileInfoEdit;
